'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

function checkContentLength(content) {
  return content.text.length <= 6;
}

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('transition', {
      attrs: {
        "name": "nav-options"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.show,
        expression: "show"
      }],
      class: ['nav-options', _vm.withoutIcon ? 'nav-options-without-icon' : ''],
      style: _vm.style
    }, _vm._l(_vm.options, function (item, index) {
      return _c('div', {
        key: index,
        staticClass: "nav-options-item",
        on: {
          "click": function click($event) {
            _vm.$emit('clickItem', index, item, $event);
          }
        }
      }, [!_vm.withoutIcon && item.iconClass ? _c('i', {
        staticClass: "nav-options-icon-class",
        class: item.iconClass
      }) : !_vm.withoutIcon && item.iconUrl ? _c('img', {
        staticClass: "nav-options-icon-url",
        attrs: {
          "src": item.iconUrl
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "nav-options-text"
      }, [_vm._v(_vm._s(item.text))])]);
    }), 0)]);
  },
  staticRenderFns: [],
  name: 'nav-options',
  props: {
    options: {
      type: Array,
      default: function _default() {},
      validator: function validator(options) {
        if (!options.every(checkContentLength)) {
          console.warn('文字内容长度建议6个字以内');
          return false;
        }

        return true;
      }
    },
    show: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0.2rem'
    },
    right: {
      type: String,
      default: '0.2rem'
    }
  },
  computed: {
    style: function style() {
      return {
        top: this.top,
        right: this.right
      };
    },
    withoutIcon: function withoutIcon() {
      return this.options.every(function (option) {
        return !option.iconClass && !option.iconUrl;
      });
    }
  }
});

exports.default = index;
